// libs
import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import SelectWrapper from "../../../../Utils/Input/SelectWrapper";
import { useForm } from "react-hook-form";
import axios from "../../../../../axios-defaults";
import Spinner from "../../../../UI/Spinner";

const ReplaceCardPanel = (props) => {
    const { t, i18n } = useTranslation();
    const { cardData: {cardNumber}, remplacementReasons } = props;
    const { register, handleSubmit } = useForm();
	const [loading, setLoading] = useState(false);

	const submitHandler = async submitData => {
		setLoading(true);

		axios.patch(`/cards/ReplaceCreditCard`, submitData)
            .then(response => {
				if (response.data.succeeded) {
					toast.success(
						<div>
							<i className="far fa-credit-card"></i>&nbsp;&nbsp;{t('account.cards.management.replace_card.success')}
						</div>
					);
                	props.closeModal();
					props.reloadCardSummary();
				}
				setLoading(false);

			})
            .catch(error => {
                toast.error(
                    <div>
						<i className="fal fa-exclamation-circle"></i>&nbsp;{error.response.data ? error.response.data.message : error.message }
                    </div>
                );
                console.log('[ReplaceCardPanel.js] : Ajax error in submitHandler()',error.message);
				setLoading(false);
			});
    };

    return (
		loading ? <Spinner/> :
			<div className="cardmanager__inner">
            <form className="form mt-4" onSubmit={handleSubmit(submitHandler)} method="post">
                <fieldset className="fieldset">
                    <strong className="label strong strong--uppercase mb-1 d-block">
                        {t('account.cards.management.replace_card.select.label')}
                    </strong>
                    <SelectWrapper>
                        <select {...register("reasonCode")} >
                            {Object.entries(remplacementReasons).map(([key, value]) => {
                                return (
                                    <option value={value.cardReplacementReason.code} key={key}>
                                        {(i18n.language === "fr") ? value.cardReplacementReason.descriptionFr : value.cardReplacementReason.descriptionEn}
                                    </option>
                                );
                            })}
                        </select>
                    </SelectWrapper>
                    <input type="hidden" value={cardNumber} {...register("cardNumber")} />
                </fieldset>

                <fieldset className="fieldset form__actions">
                    <button className="btn btn--outline btn--outline--gray action" onClick={props.cancelAction}>
                        <span className="btn__text">
                            { t('account.cards.management.buttons.cancel') }
                        </span>
                    </button>
                    <button type="submit" className="btn btn--raised btn--raised--red action">
                        <span className="btn__text">
                            { t('account.cards.management.buttons.send') }
                        </span>
                    </button>
                </fieldset>
            </form>
        </div>
    );
};

export default ReplaceCardPanel;
